/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ScheduledTransferImageMetadata = {
  /**
   * Unique identifier for a image resource.
   */
  imageID: string;
  /**
   * Alternative text for the image.
   */
  altText?: string | undefined;
  /**
   * The image's public URL.
   */
  link: string;
  /**
   * A unique identifier for an image, used in public image links.
   */
  publicID: string;
};

/** @internal */
export const ScheduledTransferImageMetadata$inboundSchema: z.ZodType<
  ScheduledTransferImageMetadata,
  z.ZodTypeDef,
  unknown
> = z.object({
  imageID: z.string(),
  altText: z.string().optional(),
  link: z.string(),
  publicID: z.string(),
});
/** @internal */
export type ScheduledTransferImageMetadata$Outbound = {
  imageID: string;
  altText?: string | undefined;
  link: string;
  publicID: string;
};

/** @internal */
export const ScheduledTransferImageMetadata$outboundSchema: z.ZodType<
  ScheduledTransferImageMetadata$Outbound,
  z.ZodTypeDef,
  ScheduledTransferImageMetadata
> = z.object({
  imageID: z.string(),
  altText: z.string().optional(),
  link: z.string(),
  publicID: z.string(),
});

export function scheduledTransferImageMetadataToJSON(
  scheduledTransferImageMetadata: ScheduledTransferImageMetadata,
): string {
  return JSON.stringify(
    ScheduledTransferImageMetadata$outboundSchema.parse(
      scheduledTransferImageMetadata,
    ),
  );
}
export function scheduledTransferImageMetadataFromJSON(
  jsonString: string,
): SafeParseResult<ScheduledTransferImageMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ScheduledTransferImageMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ScheduledTransferImageMetadata' from JSON`,
  );
}
